import { InjectionToken } from '@angular/core';
import { GoogleAnalyticsDataLayerService } from '../services';

export const DATA_LAYER_SERVICE = new InjectionToken<GoogleAnalyticsDataLayerService>('GoogleAnalyticsDataLayerService');
export const DATA_LAYER_ERROR_EVENT_TYPE = new InjectionToken<string>('dataLayerErrorEventType');
